import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { NzButtonModule } from "ng-zorro-antd/button";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzIconModule } from "ng-zorro-antd/icon";
import { IconDefinition } from "@ant-design/icons-angular";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzNotificationModule } from "ng-zorro-antd/notification";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { NzListModule } from "ng-zorro-antd/list";
import { NzModalModule } from "ng-zorro-antd/modal";

import {
  FormOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  UserOutline,
  LockOutline
} from "@ant-design/icons-angular/icons";

import { LoginComponent } from "./pages/login/login.component";
import { UserComponent } from "./pages/user/user.component";
import { DashboardComponent } from "./pages/user/dashboard/dashboard.component";
import { VideojsComponent } from "./pages/user/videojs/videojs.component";
import { PilotsComponent } from "./pages/user/pilots/pilots.component";

const icons: IconDefinition[] = [
  DashboardOutline,
  FormOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  UserOutline,
  LockOutline
];

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    UserComponent,
    DashboardComponent,
    VideojsComponent,
    PilotsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NzButtonModule,
    NzLayoutModule,
    NzCollapseModule,
    NzSkeletonModule,
    NzMenuModule,
    NzFormModule,
    NzInputModule,
    NzCheckboxModule,
    NzNotificationModule,
    NzPageHeaderModule,
    NzListModule,
    NzModalModule,
    NzIconModule.forRoot(icons)
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
